<div class="btn-group w-100">
	<button
		type="button"
		class="btn btn-primary dropdown-toggle d-flex justify-content-center align-items-center flex-nowrap"
		aria-haspopup="true"
		data-bs-toggle="dropdown"
		aria-expanded="false">
		@if (showLoadingSpinner) {
			<app-loading-spinner size="25px"></app-loading-spinner>
		} @else {
			<span style="white-space: nowrap"> {{ dropdownButton.text }} </span>
			<app-icon name="it-expand" innerClass="icon-expand icon icon-sm icon-light"></app-icon>
		}
	</button>
	<div class="dropdown-menu dropdown-menu-end">
		<div class="link-list-wrapper">
			<ul class="link-list">
				@for (item of dropdownButton.droppedItems; track $index) {
					<li>
						<button class="dropdown-item list-item" (click)="item.onClick()">
							<app-icon
								[name]="item.iconName"
								[color]="item.highlight ? 'var(--blue)' : 'black'"></app-icon>
							<span [class]="item.highlight ? 'highlighted-item' : ''">
								{{ item.text }}
							</span>
						</button>
					</li>
				}
			</ul>
		</div>
	</div>
</div>
